import LoginModal from './Content';

export default function AuthModalContentLogin({ id }: { id: bigint }) {
  return <LoginModal id={id} />;
}
